import { Routes } from "@angular/router"
import { HomeComponent } from "./pages/home.component"
import { PageNotFoundComponent } from "./shared/components/pagenotfound/pagenotfound.component"
import { SeasonMetricsComponent } from "./pages/season-metrics/season-metrics.component"
import { AuthGuard } from "./core/guards/auth.guard"
import { PizarraComponent } from "./pages/pizarra/pizarra.component"
import { EditorGuard } from "./core/guards/editor.guard"
import { SorteoComponent } from "./pages/sorteo/sorteo.component"
import { DBComponent } from "./pages/db/db.component"
import { AboutComponent } from "./shared/components/about/about.component"
import { LegalComponent } from "./shared/components/legal/legal.component"
import { PrivacyComponent } from "./shared/components/privacy/privacy.component"
import { OverlayComponent } from "./overlay.component"
import { WidgetsGuard } from "./core/guards/widgets.guard"
import { SuperordenadorComponent } from "./pages/stream/components/superordenador/superordenador.component"
import { BannerComponent } from "./pages/stream/components/banner/banner.component"
import { StreamOverlayComponent } from "./pages/stream/components/overlay/stream-overlay.component"
import { SponsorComponent } from "./pages/stream/components/sponsor/sponsor.component"
import { ComingSoonComponent } from "./shared/components/comingsoon/comingsoon.component"
import { LineupComponent } from "./pages/lineup/lineup.component"
import { AtletiTeamComponent } from "./pages/teams/atleti-team.component"

export const routes: Routes = [
  { path: 'widgets', children:[
    {path: 'superordenador', canActivate:[WidgetsGuard], component: SuperordenadorComponent},
    {path: 'banner', canActivate:[WidgetsGuard], component: BannerComponent},
    {path: 'overlay', canActivate:[WidgetsGuard], component: StreamOverlayComponent},
    {path: 'sponsor', canActivate:[WidgetsGuard], component: SponsorComponent}
  ]},
  { path: '', component: OverlayComponent, children: [
    { path: 'db/matches', canActivate: [AuthGuard], loadChildren: () => import('./pages/matches/matches.routes').then(m => m.matchesRoutes) },
    { path: 'db', component: DBComponent, children: [
      { path: 'atscore', title:"AT Score", loadChildren: () => import('./pages/scores/scores.routes').then(m => m.scoresRoutes)}, 
      { path: 'stats', canActivate: [AuthGuard], loadChildren: () => import('./pages/atleti-metrics/atleti-metrics.routes').then(m => m.atletiMetricsRoutes)}, 
      { path: 'season', canActivate: [EditorGuard], component: SeasonMetricsComponent },
      { path: 'players', loadChildren: () => import('./pages/players/players.routes').then(m => m.playerRoutes) },
      { path: 'teams', canActivate: [AuthGuard], loadChildren: () => import('./pages/teams/teams.routes').then(m => m.teamRoutes) },
      { path: 'atletiplayers', canActivate: [AuthGuard], component: AtletiTeamComponent },
      { path: 'cantera', canActivate: [AuthGuard], loadChildren: () => import('./pages/cantera/cantera.routes').then(m => m.canteraRoutes) },
      { path: '', redirectTo: 'stats', pathMatch: 'full' },
    ]},
    { path: 'sorteo', component: SorteoComponent },
    { path: 'pizarra', canActivate: [EditorGuard], component: PizarraComponent },
    { path: 'lineup', component: LineupComponent },
    { path: 'auth', loadChildren: () => import('./pages/auth/auth.routes').then(m => m.authRoutes)}, 
    { path: 'news', loadChildren: () => import('./pages/news/news.routes').then(m => m.newsRoutes)}, 
    { path: 'home', component: HomeComponent },
    { path: 'quiz', loadChildren: () => import('./pages/quiz/quiz.routes').then(m => m.quizRoutes) },
    { path: '', redirectTo: 'home', pathMatch: 'full' },
    //{ path: 'maintenance', component: MaintenanceComponent },
    { path: 'about', component: AboutComponent },
    { path: 'legal', component: LegalComponent },
    { path: 'privacy', component: PrivacyComponent },
    { path: 'comingsoon', component: ComingSoonComponent },
    { path: 'stream', canActivate: [EditorGuard], loadChildren: () => import('./pages/stream/stream.routes').then(m => m.streamRoutes)}, 
  ]},
  { path: '**', component: PageNotFoundComponent },
]